import * as XLSX from "xlsx";

export function normalizarEncabezado(valor) {
  return String(valor || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
}

export function descargarPlantillaExcel(headers, filaEjemplo = [], filename) {
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.aoa_to_sheet([headers, filaEjemplo]);
  XLSX.utils.book_append_sheet(workbook, worksheet, "Plantilla");
  XLSX.writeFile(workbook, filename.endsWith(".xlsx") ? filename : `${filename}.xlsx`);
}

export async function leerPrimeraHoja(file) {
  const buffer = typeof file.arrayBuffer === "function"
    ? await file.arrayBuffer()
    : await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(reader.error);
      reader.readAsArrayBuffer(file);
    });
  const workbook = XLSX.read(buffer, { type: "array" });
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" });
  return rows.filter((row) => Array.isArray(row) && row.some((cell) => String(cell).trim() !== ""));
}

export function filasComoObjetos(rows, headers) {
  if (!rows?.length) return { filas: [], faltantes: headers, error: "El archivo no contiene registros para importar." };

  const encabezados = rows[0].map((h) => String(h).trim());
  const normalizados = encabezados.map(normalizarEncabezado);
  const indices = {};
  headers.forEach((header) => {
    indices[header] = normalizados.findIndex((h) => h === normalizarEncabezado(header));
  });
  const faltantes = headers.filter((header) => indices[header] === -1);
  if (faltantes.length) {
    return { filas: [], faltantes, error: `Faltan columnas: ${faltantes.join(", ")}` };
  }

  const filas = rows.slice(1).map((row) => {
    const obj = {};
    headers.forEach((header) => {
      obj[header] = row[indices[header]] ?? "";
    });
    return obj;
  });

  return { filas, faltantes: [], error: null };
}
